export const googleMapKey: string = process.env.REACT_APP_GOOGLE_MAP || "";
export const sentryKey: string | undefined =
  process.env.REACT_APP_SENTRY || undefined;
export const appVersion: string = process.env.npm_package_version || "";
